import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageTitle } from "./AdminLayout";

const FILTERS = [["", "Semua"], ["ticket", "Tiket"], ["checkin.manual_override", "Override GPS"], ["checkin", "Check-in"], ["route", "Jalur"], ["lead", "Lead"], ["event", "Event"], ["participant", "Peserta"], ["feed", "Feed"], ["staff", "Staf / izin"], ["waiver", "Waiver"], ["settings", "Pengaturan"]];
const show = (v) => (v == null ? "-" : typeof v === "object" ? JSON.stringify(v) : String(v));

function AuditTable() {
  const [f, setF] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/audit", { params: { action: f } }).then((r) => setItems(r.data.items));
  }, [f]);
  return (
    <div className="space-y-3">
      <Select value={f || "all"} onValueChange={(v) => setF(v === "all" ? "" : v)}>
        <SelectTrigger className="w-full bg-white sm:w-56" data-testid="audit-filter-select"><SelectValue /></SelectTrigger>
        <SelectContent>{FILTERS.map(([v, l]) => <SelectItem key={v || "all"} value={v || "all"}>{l}</SelectItem>)}</SelectContent>
      </Select>
      <div className="overflow-x-auto rounded-2xl bg-white ring-1 ring-[#1A3323]/10">
        <Table data-testid="audit-table">
          <TableHeader><TableRow><TableHead>Waktu</TableHead><TableHead>Aktor</TableHead><TableHead>Aksi</TableHead><TableHead>Target</TableHead><TableHead>Sebelum → Sesudah</TableHead><TableHead>Alasan / Detail</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((i) => (
              <TableRow key={i.id}>
                <TableCell className="whitespace-nowrap text-xs">{fmtDateTime(i.created_at)}</TableCell>
                <TableCell className="text-xs"><b>{i.actor_name}</b><div className="text-muted-foreground">{i.role}</div></TableCell>
                <TableCell className="font-mono text-xs font-bold">{i.action}</TableCell>
                <TableCell className="text-xs">{i.target}{i.meta?.number ? ` ${i.meta.number}` : ""}{i.meta?.name ? ` ${i.meta.name}` : ""}</TableCell>
                <TableCell className="max-w-[220px] truncate font-mono text-xs">{show(i.previous_state)} → {show(i.new_state)}</TableCell>
                <TableCell className="max-w-xs truncate text-xs">{i.reason || show(i.meta)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

function PushDeliveryLog() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/push-deliveries").then((r) => setItems(r.data.items));
  }, []);
  return (
    <div className="space-y-2" data-testid="push-delivery-log-list">
      <p className="text-xs text-muted-foreground">50 pengiriman terakhir beserta status penerimaan dari OneSignal.</p>
      {!items && <p className="text-sm text-muted-foreground">Memuat log...</p>}
      {items?.length === 0 && <p className="text-sm text-muted-foreground">Belum ada pengiriman push.</p>}
      {items?.map((item) => (
        <div key={item.id} className="rounded-xl bg-white p-3 ring-1 ring-[#1A3323]/10" data-testid="push-delivery-log-item">
          <div className="flex items-center justify-between gap-2 text-sm font-bold text-[#1A3323]">
            <span>{item.title}</span>
            <span className={item.accepted ? "text-green-700" : "text-red-700"}>{item.accepted ? "Terkirim" : "Gagal"}</span>
          </div>
          <p className="mt-1 text-xs text-muted-foreground">{item.source} · {item.target_kind} · {fmtDateTime(item.created_at)}</p>
          {item.error && <p className="mt-1 text-xs text-red-700">{item.error}</p>}
        </div>
      ))}
    </div>
  );
}

export default function Audit() {
  return (
    <div>
      <PageTitle title="Audit Log" desc="Jejak perubahan status kritis dan log notifikasi push." />
      <Tabs defaultValue="audit">
        <TabsList className="mb-4" data-testid="audit-tabs">
          <TabsTrigger value="audit" data-testid="audit-tab-activity">Aktivitas</TabsTrigger>
          <TabsTrigger value="push" data-testid="audit-tab-push">Notifikasi push</TabsTrigger>
        </TabsList>
        <TabsContent value="audit"><AuditTable /></TabsContent>
        <TabsContent value="push"><PushDeliveryLog /></TabsContent>
      </Tabs>
    </div>
  );
}
